export default function formatMessageContentSwiperIcon ({
    data: swiperList/* ,
    guide_text,
    mode */
}) {
    return {
        swiperList: swiperList.map(swiperItem => {
            return {
                name: swiperItem.name,
                image: swiperItem.img_url,
                data: swiperItem.send
            }
        })
    }
}
